/**
 * Created by Jerker Nord on 2024-08-26.
 */
import {IceIceYetiToggleWinNumber} from "./IceIceYetiToggleWinNumber";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";

export class IceIceYetiWinTogglePool {

    private static _winToggles: IceIceYetiToggleWinNumber[];

    constructor() {
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, (event:GameEvent) => this.init());
    }

    private init(): void {
        IceIceYetiWinTogglePool._winToggles = [];
        for (let i: number = 0; i < 1; i++) {
            IceIceYetiWinTogglePool._winToggles.push(IceIceYetiWinTogglePool.createWinToggleNumber());
        }
    }

    private static createWinToggleNumber():IceIceYetiToggleWinNumber{
        return new IceIceYetiToggleWinNumber();
    }

    public static getWinToggleNumber(amount:number, ways:number): IceIceYetiToggleWinNumber {
        for (let i:number=0;i<this._winToggles.length;i++){
            if (this._winToggles[i].isUsed == false){
                this._winToggles[i].setAmount(amount);
                this._winToggles[i].setWays(ways);
                return this._winToggles[i];
            }
        }
        this._winToggles.push(this.createWinToggleNumber());
        return this.getWinToggleNumber(amount, ways);
    }
}